import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-6 col-xl-3 d-flex mb-4" }
const _hoisted_2 = { class: "card w-100" }
const _hoisted_3 = { class: "card-header d-flex" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "card-body d-flex flex-column justify-content-center align-items-center py-2" }
const _hoisted_6 = { class: "card-title h4 mb-0 text-nowrap fw-bold" }
const _hoisted_7 = { class: "card-title h4 text-nowrap fw-bold" }
const _hoisted_8 = { class: "card-footer" }
const _hoisted_9 = { class: "d-flex justify-content-center small" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "col-12 col-sm-6 col-xl-3 d-flex mb-4" }
const _hoisted_12 = { class: "card w-100" }
const _hoisted_13 = { class: "card-body d-flex flex-column justify-content-center align-items-center py-2" }
const _hoisted_14 = { class: "card-title mb-0 text-nowrap" }
const _hoisted_15 = { class: "card-title text-nowrap" }
const _hoisted_16 = { class: "col-12 col-sm-6 col-xl-3 d-flex mb-4" }
const _hoisted_17 = { class: "card w-100" }
const _hoisted_18 = { class: "card-body d-flex flex-column justify-content-center align-items-center py-2" }
const _hoisted_19 = { class: "card-title mb-0 text-nowrap" }
const _hoisted_20 = { class: "card-title text-nowrap" }
const _hoisted_21 = { class: "col-12 col-sm-6 col-xl-3 d-flex mb-4" }
const _hoisted_22 = { class: "card w-100" }
const _hoisted_23 = { class: "card-body d-flex flex-column justify-content-center align-items-center py-2" }
const _hoisted_24 = { class: "card-title h4 text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h5", null, [
            _createElementVNode("i", { class: "fas fa-cash-register me-2 text-red" }),
            _createTextVNode("Disponible ")
          ], -1)),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary ms-auto",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getSummaryData && _ctx.getSummaryData(...args))),
            disabled: _ctx.isSummaryLoading
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-sync-alt", { 'fa-spin': _ctx.isSummaryLoading }])
            }, null, 2)
          ], 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.summaryAvailable) + " BTC", 1),
          _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-100 my-2" }, null, -1)),
          _createElementVNode("h5", _hoisted_7, "$ " + _toDisplayString(_ctx.availableUSD) + " USD", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedUpdatedDate), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h5", null, [
            _createElementVNode("i", { class: "fas fa-money-check me-2" }),
            _createTextVNode("Asignado ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.summaryAssigned) + " BTC", 1),
          _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "w-100 my-2" }, null, -1)),
          _createElementVNode("h6", _hoisted_15, "$ " + _toDisplayString(_ctx.assignedUSD) + " USD", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h5", null, [
            _createElementVNode("i", { class: "fas fa-coins me-2" }),
            _createTextVNode("Total ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.summaryTotal) + " BTC", 1),
          _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "w-100 my-2" }, null, -1)),
          _createElementVNode("h6", _hoisted_20, "$ " + _toDisplayString(_ctx.totalUSD) + " USD", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h5", null, [
            _createElementVNode("i", { class: "fab fa-bitcoin me-2 text-yellow" }),
            _createTextVNode("Precio BTC ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h5", _hoisted_24, "$ " + _toDisplayString(_ctx.formattedBTCPrice) + " USD", 1)
        ])
      ])
    ])
  ], 64))
}